module.exports = __webpack_public_path__ + "img/Tong Sampah Penuh Icon.22c72deb.png";